


const YouTubePlaylist = ({src}) => {

    return <div id="YouTubePlaylistContainer" className='fixed top-80 left-80 flex items-center w-auto h-auto justify-center z-50'>
        <iframe className='justify-center' width="560" height="315" src={src} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
    </div>;
  };
  export default YouTubePlaylist;